/** 
 * @sort id
 */
export default [
    {
        text: "folio",
        value: "id",
        sortable: 'id',
    },
    {
        text: "rut",
        value: "sl_customer_rut",
        format: "rut",
    },
    {
        text: "cliente",
        value: "sl_customer_alias_name",
    },
    {
        text: "vendedor",
        value: "g_seller_user_full_name",
    },
    {
        text: "tipo",
        value: "pos_sale_type_name",
        align: "center",
        component: {
            type: "chip",
            custom: "has_pos_sale_type_id",
            props: {
                disabled: true,
                label: true,
                small: true,
                textColor: "black",
            }
        },
    },
    {
        text: "fecha de creación",
        value: "created_at",
        align: "right",
    },
    {
        text: "estado",
        value: "g_state_name_with_new_pos_sale",
        align: "center",
        component: {
            type: "chip",
            custom: "has_g_state",
            props: {
                disabled: true,
                label: true,
                small: true,
                textColor: "black",
            }
        },
    }, 
    {
        text: "total",
        value: "invoice_total",
        format: "currency",
        align: "right",
        active: true
    }, 
]